  <!--Only show for a user that is not admin-->
<div #itemImageSection>
  @if(isVisible) {
  <kendo-grid style="width:450px" #ItemImageGrid
              id="ItemImage_Grid"
              [pageSize]="10"
              [data]="itemImageGridData"
              [sortable]="false"
              [reorderable]="false"
              [selectable]="true"
              [resizable]="true"
              [groupable]="false"
              [navigable]="true"
              (remove)="removeImageHandler($event)">

    <ng-template kendoGridToolbarTemplate>
      <kendo-upload [autoUpload]="false"
                    [saveUrl]="uploadSaveUrl"
                    [removeUrl]="uploadRemoveUrl"
                    [restrictions]="uploadRestrictions"
                    [chunkable]="chunkSettings"
                    [disabled]="isReadOnly"
                    (remove)="remove($event)"
                    (select)="select($event)">
      </kendo-upload>
    </ng-template>

    <kendo-grid-column title="Name" filter="text" [width]="80" [editable]="false">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="customer-name">{{ dataItem['name'] }}</div>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="Image" filter="text" [width]="80" [editable]="false">
      <ng-template kendoGridCellTemplate let-dataItem>
        <div class="image-photo"
             [ngStyle]="{ 'background-image': photoURL(dataItem) }"></div>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-command-column title="Actions" [width]="150">
      <ng-template kendoGridCellTemplate>
        <button kendoGridRemoveCommand type="button" [disabled]="isReadOnly" [primary]="true">Remove</button>
      </ng-template>
    </kendo-grid-command-column>
    this.itemImageResults
  </kendo-grid>
  }
  <br />
  @if(!isEmpty) {
  <kendo-scrollview [data]="items"
                    [width]="width"
                    [height]="height"
                    [animate]="false"
                    [pagerOverlay]="'dark'"
                    [arrows]="true"
                    [pageable]="true">
    <ng-template let-item="item">
      <img class="displayImage"
           src="{{ item.image }}"
           alt="{{ item.name }}"
           draggable="false" />
    </ng-template>
  </kendo-scrollview>
  }

</div>
